export default __webpack_public_path__ + "static/media/StarRating.ab55fc84.jpg";